import { getMunData } from "utils";
const data = getMunData();

const contactEnglish = {
  title: "Contact",
  text:
    "See something wrong in the data? Or got any feedback suggestions to help make this platform better? Use the form below to reach out to us.",
  addressText1: `${data.municipality_title_en}`,
  addressText2: `${data.contact_en.region}, ${data.contact_en.location}`,
  addressText3: "Planning Division",
  addressText: "Address",
  phoneText: "Phone",
  phone: `${data.contact_en.phn_no}`,
  tollFree: data.contact_en.toll_free,
  emailText: "Email",
  email1: `${data.contact_en.email1}`,
  email2: `${data.contact_en.email2}`,
  website: data.contact_en.website,
  tollFreeText: "(Toll Free no.)",
};

const contactNepali = {
  title: "सम्पर्क गर्नुहोस्",
  text:
    "तथ्यांकमा केही त्रुटी छ वा यसलाई थप राम्राे बनाउनका लागि कुनै सल्लाह/सुझाव छ ? तल दिइएका फारमकाे प्रयाेग गरी हामीसँग सम्पर्क गर्नुहाेस् ।",
  addressText1: `${data.municipality_title}`,
  addressText2: `${data.contact_np.region}, ${data.contact_np.location}`,
  addressText3: "येाजना विभाग",
  addressText: "ठेगाना",
  phoneText: "फेान",
  phone: `${data.contact_np.phn_no}`,
  tollFree: data.contact_np.toll_free,
  emailText: "इमेल",
  email1: `${data.contact_np.email1}`,
  email2: `${data.contact_np.email2}`,
  website: data.contact_np.website,
  tollFreeText: "(टोल फ्री नं)",
};

export { contactEnglish, contactNepali };



// WEBPACK FOOTER //
// ./src/localization/contact.js